var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Photo",
    d: "M28.6111 53.6667L41.3889 69L59.2778 46L82.2778 76.6667H10.7222L28.6111 53.6667ZM92.5 81.7778V10.2222C92.5 4.54889 87.9 0 82.2778 0H10.7222C8.01112 0 5.41106 1.07698 3.49402 2.99402C1.57698 4.91106 0.5 7.51112 0.5 10.2222V81.7778C0.5 84.4889 1.57698 87.0889 3.49402 89.006C5.41106 90.923 8.01112 92 10.7222 92H82.2778C84.9889 92 87.5889 90.923 89.506 89.006C91.423 87.0889 92.5 84.4889 92.5 81.7778Z",
    fill: "#D0D5DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoEmpty);
export default __webpack_public_path__ + "static/media/photo_empty.f7bbd7b9662d14d92ba4193682a09342.svg";
export { ForwardRef as ReactComponent };